export default __webpack_public_path__ + "static/media/logo-white.4db2eb2e.png";